/* ARC NOIRE — 3D record sleeve, ported from the original React Three Fiber
 * component to vanilla three.js (loaded from CDN as an ES module) so it can
 * run inside a Shopify theme without a JS build step. */
(function () {
  "use strict";

  var stage = document.querySelector("[data-sleeve-stage]");
  if (!stage) return;

  var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reducedMotion) return; // fallback markup (already in the DOM) stays visible

  var RED = "#d92322";
  var PAPER = "#e4e0d6";
  var INK = "#141414";

  var CATALOG_NO = stage.getAttribute("data-catalog-no") || "AN-001";
  var SEASON = stage.getAttribute("data-season") || "FALL 2026";
  var DROP = stage.getAttribute("data-drop") || "DROP 001";
  var RELEASE = stage.getAttribute("data-release") || "OFF THE RECORD";

  /* Product list for the back-cover tracklist. Reads from the drop
   * collection if a JSON blob is present (see hero-drop.liquid), otherwise
   * falls back to generic placeholder rows. */
  var products = [];
  try {
    var dataEl = document.getElementById("sleeve-tracklist-data");
    if (dataEl) products = JSON.parse(dataEl.textContent);
  } catch (e) {
    products = [];
  }

  import("https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js")
    .then(function (THREE) {
      init(THREE);
    })
    .catch(function (err) {
      console.error("Could not load three.js for the sleeve viewer", err);
    });

  function makeCanvas(draw) {
    var size = 1024;
    var canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    var ctx = canvas.getContext("2d");
    draw(ctx, size);
    var img = ctx.getImageData(0, 0, size, size);
    var d = img.data;
    for (var i = 0; i < d.length; i += 4) {
      var n = (Math.random() - 0.5) * 34;
      d[i] = d[i] + n;
      d[i + 1] = d[i + 1] + n;
      d[i + 2] = d[i + 2] + n;
    }
    ctx.putImageData(img, 0, 0);
    return canvas;
  }

  function regMarks(c, s, color) {
    c.strokeStyle = color;
    c.lineWidth = 2;
    var m = 34;
    var d = 18;
    var pts = [
      [m, m],
      [s - m, m],
      [m, s - m],
      [s - m, s - m],
    ];
    pts.forEach(function (pt) {
      var x = pt[0], y = pt[1];
      c.beginPath();
      c.moveTo(x - d, y);
      c.lineTo(x + d, y);
      c.moveTo(x, y - d);
      c.lineTo(x, y + d);
      c.stroke();
      c.beginPath();
      c.arc(x, y, 8, 0, Math.PI * 2);
      c.stroke();
    });
  }

  function frontCanvas() {
    return makeCanvas(function (c, s) {
      c.fillStyle = INK;
      c.fillRect(0, 0, s, s);
      regMarks(c, s, "#5a5a5a");

      c.fillStyle = RED;
      c.fillRect(70, 300, s - 140, 250);

      c.fillStyle = INK;
      c.textAlign = "left";
      c.font = "700 128px Arial, Helvetica, sans-serif";
      c.fillText("OFF THE", 96, 420);
      c.fillText("RECORD", 96, 530);

      c.fillStyle = PAPER;
      c.font = "600 46px Arial, Helvetica, sans-serif";
      c.fillText("ARC NOIRE", 96, 180);
      c.font = "22px monospace";
      c.fillText(SEASON + "  /  " + DROP, 96, 230);
      c.fillText("CATALOG NO. " + CATALOG_NO, 96, 640);
      c.fillText("SIDE A / SIDE B \u2014 6 TRACKS", 96, 680);

      c.fillStyle = RED;
      c.beginPath();
      c.arc(s - 210, s - 200, 120, 0, Math.PI * 2);
      c.fill();
      c.fillStyle = PAPER;
      c.textAlign = "center";
      c.font = "700 40px Arial, Helvetica, sans-serif";
      c.fillText("AN-001", s - 210, s - 208);
      c.font = "20px monospace";
      c.fillText(DROP, s - 210, s - 172);

      c.strokeStyle = "#3a3a3a";
      c.lineWidth = 3;
      c.strokeRect(40, 40, s - 80, s - 80);
    });
  }

  function backCanvas() {
    return makeCanvas(function (c, s) {
      c.fillStyle = PAPER;
      c.fillRect(0, 0, s, s);
      regMarks(c, s, "#9a968c");

      c.fillStyle = RED;
      c.fillRect(0, 0, s, 90);
      c.fillStyle = PAPER;
      c.textAlign = "left";
      c.font = "700 44px Arial, Helvetica, sans-serif";
      c.fillText("ARC NOIRE \u2014 " + RELEASE, 60, 60);

      c.fillStyle = INK;
      c.font = "22px monospace";
      c.fillText(SEASON + "  \u00b7  " + CATALOG_NO + "  \u00b7  " + DROP, 60, 150);

      var y = 240;
      ["A", "B"].forEach(function (side) {
        c.fillStyle = RED;
        c.font = "700 42px Arial, Helvetica, sans-serif";
        c.fillText("SIDE " + side, 60, y);
        y += 20;
        c.fillStyle = INK;
        c.fillRect(60, y, s - 120, 2);
        y += 54;
        products
          .filter(function (p) { return p.side === side; })
          .forEach(function (p) {
            c.fillStyle = INK;
            c.font = "26px monospace";
            c.fillText(p.track, 60, y);
            c.font = "600 30px Arial, Helvetica, sans-serif";
            c.fillText(p.name, 140, y);
            c.textAlign = "right";
            c.font = "24px monospace";
            c.fillText(p.sku, s - 60, y);
            c.textAlign = "left";
            y += 52;
          });
        y += 40;
      });

      c.fillStyle = "#5a564e";
      c.font = "18px monospace";
      c.fillText("ALL GARMENTS RECORDED IN LOW LIGHT. NO MASTER COPY.", 60, s - 60);
    });
  }

  function edgeCanvas(text) {
    return makeCanvas(function (c, s) {
      c.fillStyle = INK;
      c.fillRect(0, 0, s, s);
      c.fillStyle = RED;
      c.fillRect(0, s * 0.42, s, s * 0.16);
      c.save();
      c.translate(s / 2, s / 2);
      c.fillStyle = PAPER;
      c.textAlign = "center";
      c.font = "700 64px Arial, Helvetica, sans-serif";
      c.fillText(text, 0, 22);
      c.restore();
    });
  }

  function init(THREE) {
    var width = stage.clientWidth;
    var height = stage.clientHeight;

    var renderer = new THREE.WebGLRenderer({ antialias: true, powerPreference: "high-performance" });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.75));
    renderer.setSize(width, height);

    var fallback = stage.querySelector("[data-sleeve-fallback]");
    if (fallback) fallback.style.display = "none";
    stage.appendChild(renderer.domElement);

    var scene = new THREE.Scene();
    scene.background = new THREE.Color("#1a1a1c");

    var camera = new THREE.PerspectiveCamera(42, width / height, 0.1, 100);
    camera.position.set(0, 0, 6);

    scene.add(new THREE.AmbientLight(0xffffff, 0.55));
    var key = new THREE.DirectionalLight(0xffffff, 2.1);
    key.position.set(4, 6, 6);
    scene.add(key);
    var rim = new THREE.DirectionalLight(0xd92322, 0.7);
    rim.position.set(-5, -2, 3);
    scene.add(rim);

    function tex(canvas) {
      var t = new THREE.CanvasTexture(canvas);
      t.colorSpace = THREE.SRGBColorSpace;
      t.anisotropy = 4;
      return t;
    }
    var edgeTex = tex(edgeCanvas("ARC NOIRE \u00b7 " + CATALOG_NO));
    var frontTex = tex(frontCanvas());
    var backTex = tex(backCanvas());

    function mat(map) {
      return new THREE.MeshStandardMaterial({ map: map, roughness: 0.82, metalness: 0.05 });
    }
    var materials = [mat(edgeTex), mat(edgeTex), mat(edgeTex), mat(edgeTex), mat(frontTex), mat(backTex)];

    var group = new THREE.Group();
    var viewportWidthAtZ = 2 * 6 * Math.tan((42 * Math.PI / 180) / 2) * (width / height);
    var scale = Math.min(1, viewportWidthAtZ / 6.2);
    group.scale.setScalar(scale);

    var box = new THREE.Mesh(new THREE.BoxGeometry(3.1, 3.1, 0.22), materials);
    group.add(box);

    var spine = new THREE.Mesh(
      new THREE.BoxGeometry(0.06, 1.2, 0.24),
      new THREE.MeshStandardMaterial({ color: RED, roughness: 0.6 })
    );
    spine.position.set(-1.62, 0, 0);
    group.add(spine);

    scene.add(group);

    var drag = { x: 0, y: 0 };
    var active = false;
    var last = { x: 0, y: 0 };

    stage.addEventListener("pointerdown", function (e) {
      active = true;
      stage.classList.add("is-grabbing");
      last.x = e.clientX;
      last.y = e.clientY;
    });
    stage.addEventListener("pointermove", function (e) {
      var w = stage.clientWidth || 1;
      var h = stage.clientHeight || 1;
      if (active) {
        drag.x += (e.clientX - last.x) / w;
        drag.y += (e.clientY - last.y) / h;
        drag.x = Math.max(-1.2, Math.min(1.2, drag.x));
        drag.y = Math.max(-0.35, Math.min(0.35, drag.y));
        last.x = e.clientX;
        last.y = e.clientY;
      } else {
        var rect = stage.getBoundingClientRect();
        drag.x = ((e.clientX - rect.left) / rect.width - 0.5) * 0.5;
        drag.y = ((e.clientY - rect.top) / rect.height - 0.5) * 0.2;
      }
    });
    function release() {
      active = false;
      stage.classList.remove("is-grabbing");
    }
    stage.addEventListener("pointerup", release);
    stage.addEventListener("pointerleave", release);

    var clock = new THREE.Clock();
    function animate() {
      requestAnimationFrame(animate);
      var delta = Math.min(clock.getDelta(), 0.05);
      var t = clock.elapsedTime;
      var targetY = drag.x * 2.6 + Math.sin(t * 0.25) * 0.22;
      var targetX = drag.y * 1.1 + Math.sin(t * 0.18) * 0.08;
      var k = 1 - Math.exp(-6 * delta);
      group.rotation.y += (targetY - group.rotation.y) * k;
      group.rotation.x += (targetX - group.rotation.x) * k;
      group.position.y = Math.sin(t * 0.6) * 0.06;
      renderer.render(scene, camera);
    }
    animate();

    window.addEventListener("resize", function () {
      var w = stage.clientWidth;
      var h = stage.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    });
  }
})();
